import { FormControl, FormErrorMessage, Flex } from "@chakra-ui/react";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import PrimaryButton from "../PrimaryButton";
import Input from "../inputs/Input";
import { Center } from "../../pages/SignInPage";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

type CreateCenterFormProps = {
	onSubmit?: (address: Center) => void;
};

const centerSchema = z.object({
	company: z.string().min(1, { message: "Ce champ est requis." }),
	name: z.string().min(1, { message: "Ce champ est requis." }),
	phoneNumber: z
		.string()
		.min(1, { message: "Ce champ est requis." })
		.regex(/^\+?\d+$/, { message: "Doit être un numéro de téléphone valide" }),
	email: z
		.string()
		.min(1, { message: "Ce champ est requis." })
		.email({ message: "Ce n'est pas un email valide." }),
});

function CreateCenterForm({ onSubmit }: CreateCenterFormProps) {
	const methods = useForm({
		resolver: zodResolver(centerSchema),
	});

	const transformFields = (fields: FieldValues) => {
		return {
			company: fields.company,
			name: fields.name,
			phoneNumber: fields.phoneNumber,
			email: fields.email,
		};
	};
	const handleSubmit = async () => {
		try {
			const valid = await methods.trigger();
			if (valid && onSubmit) {
				onSubmit(transformFields(methods.getValues()));
			}
		} catch (err) {
			// Todo: Sentry
		}
	};
	return (
		<Flex w="100%">
			<FormProvider {...methods}>
				<form style={{ marginTop: "32px", width: "100%" }}>
					<Flex direction="column" gap="24px">
						<FormControl isInvalid={!!methods.formState.errors.company}>
							<Input
								id="company"
								placeholder="Entreprise"
								{...methods.register("company")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.company?.message}</>
							</FormErrorMessage>
						</FormControl>
						<FormControl isInvalid={!!methods.formState.errors.name}>
							<Input
								id="name"
								placeholder="Nom du centre"
								{...methods.register("name")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.name?.message}</>
							</FormErrorMessage>
						</FormControl>
						<FormControl isInvalid={!!methods.formState.errors.phoneNumber}>
							<Input
								id="phoneNumber"
								placeholder="Téléphone du centre"
								{...methods.register("phoneNumber")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.phoneNumber?.message}</>
							</FormErrorMessage>
						</FormControl>
						<FormControl isInvalid={!!methods.formState.errors.email}>
							<Input
								id="email"
								placeholder="Email du centre"
								{...methods.register("email")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.email?.message}</>
							</FormErrorMessage>
						</FormControl>

						<PrimaryButton type="button" onClick={handleSubmit}>
							Continuer
						</PrimaryButton>
					</Flex>
				</form>
			</FormProvider>
		</Flex>
	);
}

export default CreateCenterForm;
